import { compose } from 'recompose';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import { actions as recordActions } from '../../../redux/dashboard/record';
import {
  selectDashboardPatientRecordValidationError,
  selectSendingValidatePatientInfo,
  selectDashboardPatientCommonErrors,
} from '../../../redux/dashboard/selectors';
import styles from '../../DependentForm/styles.styl';

const mapStateToProps = state => ({
  patientValidationError: selectDashboardPatientRecordValidationError(state),
  commonErrors: selectDashboardPatientCommonErrors(state),
  pending: selectSendingValidatePatientInfo(state),
});

const mapDispatchToProps = {
  validatePatientInfo: recordActions.validatePatientInfo,
  clearRecordErrors: recordActions.clearErrors,
};

export const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/DashboardRecord/DashboardPatientInfo/enhance.js